/* External dependencies */
import React from 'react';
import { Provider } from 'react-redux';

/* Local dependencies */
import { SessionInitializer } from '../components/dashboard/auth/SessionInitializer';
import { createStore } from './store';

const store = createStore();

const wrapper = ({ element }) => {
  return (
    <Provider store={store}>
      <SessionInitializer>{element}</SessionInitializer>
    </Provider>
  );
};

export default wrapper;
